// Single source of truth for the GitHub orgs death-star tracks calibration
// and suppressions data for. Importing routes use this to render org
// selectors and to validate inbound org values where applicable.
export const ORGS = ['rewindio', 'rewind-corp', 'rewind-community', 'rewindio-labs'] as const;
export type Org = (typeof ORGS)[number];
